import { Tooltip } from "flowbite-react";
import { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { HiDotsHorizontal, HiOutlineTrash } from "react-icons/hi";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMenusByFilter, getMenuTotalCount, removeMenu, setCurrentWineMenu, getTreeData } from '../../redux/menuReducer';
// import { insertMenuInCart, removeMenuInCart, setCartItemActive } from '../../redux/locationReducer';
import date from 'date-and-time';
import { useTranslation } from "react-i18next";
import swal from 'sweetalert2';
import { S3_BUCKET, S3_BUCKET_RESIZE } from '../../config/constants';
import { openSnackBar } from '../../redux/snackBarReducer';
import DuplicateMenu from "./DuplicateMenu";
import Loading from "../Global/Loading";

function MenuTableItem(props) {
    const { t } = useTranslation();
    const { authState, menuState } = useSelector((state) => state);
    const { userInfo } = authState;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [permission, setPermission] = useState(false);
    const { getTreeDataState } = menuState;

    useEffect(() => {
        if (props.condition.role === 0) { // admin 
            setPermission(true);
        } else if (props.condition.role === 1) { // company owner
            // if (props.data.company._id === props.condition.company && props.data.is_global === props.condition.isGlobal) {
            //     setPermission(true);
            // } else {
            //     setPermission(false);
            // }
            setPermission(true)
        } else if (props.condition.role === 2) {// company stuff
            // if (props.data.company._id === props.condition.company && props.data.is_global === props.condition.isGlobal && props.data.created_by._id === props.condition.user_id) {
            //     setPermission(true);
            // } else {
            //     setPermission(false);
            // }
            setPermission(false)
        }
    }, [props.condition, props.data])

    const clickDelete = async (value) => {

        if (permission) {
            swal.fire({
                title: t("swal_are_you_sure"),
                text: t("swal_del_menu"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t("swal_delete")
            })
                .then(async result => {
                    if (result.isConfirmed) {
                        let res = await dispatch(removeMenu(value));
                        if (res !== false) {
                            dispatch(openSnackBar({ message: t("msg_success_del_menu"), status: 'success' }));
                            await dispatch(getMenusByFilter(props.condition));
                            await dispatch(getMenuTotalCount(props.condition));
                        }
                    }
                });
        } else {
            dispatch(openSnackBar({ status: "error", message: t("msg_not_permission") }));
        }
    }

    const gotoMenuEditPage = async () => {
        // if (permission) {
            let res = await dispatch(getTreeData(props.data._id))
            if(res != false){
                // console.log(res)

                dispatch(setCurrentWineMenu({...props.data, treeData: res.treeData, products: res.products}));
                navigate("/menuedit");
            }else{
                dispatch(openSnackBar({ status: "error", message: t("server_connect_error") }));
            }
        // } else {
        //     dispatch(openSnackBar({ status: "error", message: t("msg_not_permission") }));
        // }
    }

    const { name, restaurant_logo, created_by, created_at, modified_at, _id } = props.data;

    return (
        <>
            {
                getTreeDataState && <Loading />
            }
            <tr className={props.last ? "bg-white" : "bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"}>
                <th onClick={() => gotoMenuEditPage()} scope="row" className="flex items-center py-4 px-6 text-gray-900 whitespace-nowrap dark:text-white">
                    <div className="flex justify-center w-20 h-20">
                        {
                            restaurant_logo.changed_name ? 
                                restaurant_logo.changed_name.indexOf(".svg") != -1 ? 
                                    <img className="w-auto rounded-full" src={`${S3_BUCKET}${restaurant_logo.changed_name ? restaurant_logo.changed_name : "menu-empty.png"}`} alt="empty" />
                                :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${restaurant_logo.changed_name ? restaurant_logo.changed_name : "menu-empty.png"}`} alt="empty" />
                            :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${restaurant_logo.changed_name ? restaurant_logo.changed_name : "menu-empty.png"}`} alt="empty" />
                        }
                        {/* <img className="w-auto rounded-full" src={`${S3_BUCKET}${restaurant_logo.changed_name ? restaurant_logo.changed_name : "menu-empty.png"}`} alt="empty" /> */}
                    </div>
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{created_by?.firstname + " " + created_by?.lastname}</div>
                        <div className="text-base font-semibold">{name ? name : "N/A"}</div>
                    </div>
                </th>
                <td onClick={() => gotoMenuEditPage()} className="py-4 px-6">
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{t("created")}</div>
                        <div className="text-base font-semibold">{created_at ? date.format(new Date(created_at), 'YYYY/MM/DD HH:mm:ss') : "N/A"}</div>
                    </div>
                </td>
                <td onClick={() => gotoMenuEditPage()} className="py-4 px-6">
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{t("last_modified")}</div>
                        <div className="text-base font-semibold">{modified_at ? date.format(new Date(modified_at), 'YYYY/MM/DD HH:mm:ss') : "N/A"}</div>
                    </div>
                </td>
                <td className="py-4 px-6">
                    <Tooltip
                        style="light"
                        content={
                            <div >
                                <DuplicateMenu product_id={_id} permission={permission} />
                                <div onClick={() => gotoMenuEditPage()} className="flex text-gray-600 p-1 cursor-pointer hover:bg-gray-100">
                                    {/* <FaRegEdit className="h-5 w-5 ml-1 mr-2 text-gray-600" /> */}
                                    <svg viewBox="0 0 24 24" className="h-5 w-5 ml-1 mr-2 text-gray-600" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M12.667,14.136l-3.712.531.53-3.713,9.546-9.546A2.25,2.25,0,0,1,22.213,4.59Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.122,14.25v7.5a1.5,1.5,0,0,1-1.5,1.5h-15a1.5,1.5,0,0,1-1.5-1.5v-15a1.5,1.5,0,0,1,1.5-1.5h7.5" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                    {t("edit")}
                                </div>
                                <div onClick={() => clickDelete(_id)} className="flex text-red-500 p-1 cursor-pointer hover:bg-gray-100">
                                    {/* <HiOutlineTrash className="h-6 w-6 mr-2 text-red-500" /> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M18.0576 22.3846H5.94219C5.48317 22.3846 5.04294 22.2023 4.71836 21.8777C4.39377 21.5531 4.21143 21.1129 4.21143 20.6538V5.07692H19.7883V20.6538C19.7883 21.1129 19.606 21.5531 19.2814 21.8777C18.9568 22.2023 18.5166 22.3846 18.0576 22.3846Z"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M9.40381 17.1923V10.2692"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 17.1923V10.2692"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M0.75 5.07692H23.25"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 1.61539H9.40386C8.94484 1.61539 8.50461 1.79774 8.18003 2.12232C7.85544 2.4469 7.6731 2.88713 7.6731 3.34616V5.07693H16.3269V3.34616C16.3269 2.88713 16.1446 2.4469 15.82 2.12232C15.4954 1.79774 15.0552 1.61539 14.5962 1.61539Z"/></svg>
                                    {t("delete")}
                                </div>
                            </div>
                        }
                        placement="left"
                        arrow={false}
                        trigger="hover"
                    >
                        <HiDotsHorizontal className="w-6 h-6" />
                    </Tooltip>
                </td>
            </tr>
        </ >

    );
}

export default MenuTableItem;